<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">Terms of Use</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
          <div class="content">
        <p>
          MRS Digi Inc is a digital platform to access internet–of-things enabled services. We allow businesses to
          interact with their customers through the online platform.
        </p>

        <p>
          No Exchange, No Return Policy All Sales Are Final / Final Policy However, you may request a refund or an
          exchange if, upon receipt,

            <ol>
                <li>The products are damaged</li>
                <li>The products are defective</li>
                <li>You did not receive the products you had ordered</li>
            </ol>          
        </p>

        <p>
          You must advise service provider of any refund or exchange request within 1 hour from shipment arrival.
        </p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
  }),

  created() {},

  computed: {},

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 0px;
  color : black;
}
</style>
